<div class="footer-view">
  <div class="title">
    <span>Estas en modo visualización de Handover. </span>
    <span *ngIf="wellConditionhistoryObservations.length == 0 && handoverDataHistoryObservations.length == 0">Este
      handover no tiene historial de Observaciones.</span>
    <span *ngIf="handoverDataHistoryObservations.length > 0 || wellConditionhistoryObservations.length > 0">Podés ver
      acá el </span>
    <span *ngIf="handoverDataHistoryObservations.length > 0"><a class="view-history"
        (click)="viewDataHandoverObservationsHistory()">Historial de Observaciones en Datos del Handover</a></span>
    <span>{{ handoverDataHistoryObservations.length > 0 && wellConditionhistoryObservations.length > 0 ? ' o también el
      ' : '.' }}</span>
    <span *ngIf="wellConditionhistoryObservations.length > 0"><a class="view-history"
        (click)="viewWellConditionObservationsHistory()">Historial de Observaciones en Condición de Pozo</a>.</span>
  </div>
  <div class="grid-attachment" *ngIf = "observationAttachment.length > 0">
    <h2>Adjunto</h2>
    <div class = "attachment" *ngFor="let f of observationAttachment">
        <a
            class="attachment-link"
            href="{{dhoApiUrl}}/{{ f?.filePath }}"
            download="{{ f?.fileOriginalName }}"
            target="_blank"
        >
            {{ f?.fileOriginalName }}
        </a>
    </div>
  </div>
</div>